import script from "./NotificationToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationToast.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationToast.vue?vue&type=style&index=0&id=575cb05c&lang=css"

const __exports__ = script;

export default __exports__